import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  constructor(private router: Router,
    private viewportScroller: ViewportScroller
  ) {}

  backTop() {
    this.viewportScroller.scrollToAnchor('top-page');
  }
}

